import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      user:  null,
      token: localStorage.getItem("token"),
      theme: localStorage.getItem("portal_theme") || "dark",
      // Mirrors the backend's Employee::isAdmin() (is_master OR type==='admin'),
      // not just is_master — see AdminLoginWebApiController's is_admin field.
      // Falls back to the legacy is_master key so sessions from before this
      // change don't lose admin status until their next login; a type==='admin'
      // (non-master) employee needs to log in again to pick up the new flag.
      isAdmin: localStorage.getItem("is_admin") === "1" || localStorage.getItem("is_master") === "1",
      // Granular permission names (about.*, blog.*, recycle-bin.*, ...) — see
      // getters.can(name). Empty until the next login for pre-existing
      // sessions, same caveat as isAdmin above.
      permissions: JSON.parse(localStorage.getItem("permissions") || "[]"),
    };
  },
  mutations,
  actions,
  getters,
  namespaced: false
};
